import React, { Component, Fragment } from 'react';
import { CustomLoading, Logging } from './LoadingComponent';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem, Label, 
         Input, Button,
         Modal, ModalHeader, ModalBody, Alert, Form} from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { assets } from '../shared/data';
import { CSVLink } from "react-csv";
import { aggregate, sort_by,
         reordered_array_keys, pick, custom_sort_keys, custom_sort_by, transpose } from './Functions';
import { portfolioRound } from './analytics';

import { RenderVirtualTable } from './TableComponent';
import { PiePlot, MultBarPlot, BarPlot, MultLineTsPlot, ScatterPlot } from './PlotComponent';
import { postRequest } from '../redux/ActionCreators';
import { colors_sura } from '../shared/data';
import { port_optim_metrics_actions, port_optim_exposure_actions } from '../redux/ActionType';

// import { Auth } from 'aws-amplify';
const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    optim_saa: state.optim_saa,
    optim_port_metrics: state.optim_port_metrics,
    optim_port_exposure: state.optim_port_exposure,
    optim_params: state.optim_params
  };
};

class PortOptim extends Component {
  constructor(props){
      super(props);
      this.state = {
        loading_metrics:false,
        port_id:'Portafolio',
        show_fx:true,
        msg:null,
        msg_save:null,
        ret_period:'YTD',
        load_portfolio:false,
        saving_portfolio:false,
        exp_var: "AssetClass"
      };
      this.savePortfolio = this.savePortfolio.bind(this);
      this.roundPort = this.roundPort.bind(this);
  }
  
  async roundPort(){
    console.log("round");
    await this.props.updateState(
      "SAA_UDT_PORT",
      portfolioRound(
          this.props.optim_saa.data.port.filter(item=>item.w>1e-6)
        , 0.005, "w")
      );

      const optim_port_exp = await this.props.fetchData(
        { 
          port:this.props.optim_saa.data.port.map(x=>{
            return {name:x.name, value:x.w};
          }),
          bench:null,
        }, 'port_exposure_wm', port_optim_exposure_actions);
        
       if (optim_port_exp?.success){
          const optim_port_metrics = await this.props.fetchData(
            { 
                ref_curr:this.props.optim_params.ref_curr,
                port:this.props.optim_saa.data.port.map(x=>{
                    return {name:x.name, value:x.w};
                }),
                bench:this.props.optim_params.optim_type.slice(0,3)=="abs" ? null :this.props.optim_params.bench_name,
                views: this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).length==0 ? null : this.props.optim_cons.assetcons.filter(x=>Math.abs(x.view-x.ret)>0.01).map(
                    x=>{
                      return {name:x.name, value:x.view};
                    }),
                ini_date:this.props.assets_summ[0]['Fecha Inicial']
            }, 'port_metrics_wm', port_optim_metrics_actions);
       }

      
  }
  async savePortfolio(e){
    e.preventDefault();
    const form = e.target;

    if (form.port_name.value==null || form.port_name.value=='') {
      this.setState({msg_save:'Insertar nombre de portafolio.'});
    } else {
      this.setState({saving_portfolio:true});
      try {
        const save_port = await postRequest(
          { 
            ref_date:(new Date()).toISOString().slice(0,10),
            port_name:form.port_name.value,
            weights:this.props.optim_saa.data.port.filter(item=>item.w>0).map(item=>{
              return {Asset:item.name, Weight:item.w};
            }),
            overwrite:true
          }, 'load_portfolio');
        if (save_port.status=="ok"){
          await this.props.addPort(form.port_name.value);
          await this.props.changeModel("optim_params.msg", `Portafolio ${form.port_name.value} guardado en BD.`);
        }
        
        this.setState({
          saving_portfolio:false,
          msg_save: save_port.msg
        });
      } catch (error) {
        this.setState({
          saving_portfolio:false,
          msg_save: error.message
        });
      }
    }
  }
  
  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className="container">
            <div className="row mt-5 justify-content-center">
              <div className="col-auto">
                  <h4>Optimización</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className="col-auto">
                <Breadcrumb>
                  <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                  <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                  <BreadcrumbItem active>Resultados</BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>
            <div className="row justify-content-center">
              <Logging />
            </div>
          </div>

        );
      } else if(this.props.optim_saa.isLoading){
        return(
          <div className="container">
            <div className="row mt-5 justify-content-center">
              <div className="col-auto">
                  <h4>Optimización</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className="col-auto">
                <Breadcrumb>
                  <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                  <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                  <BreadcrumbItem active>Resultados</BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>
            <div className="row justify-content-center">
              <CustomLoading msg="optimizando portafolio" icon="fa-star"/>
            </div>
          </div>

        );
      } else if(this.props.optim_port_exposure.isLoading){
        return(
          <div className="container">
            <div className="row mt-5 justify-content-center">
              <div className="col-auto">
                  <h4>Optimización</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className="col-auto">
                <Breadcrumb>
                  <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                  <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                  <BreadcrumbItem active>Resultados</BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>
            <div className="row justify-content-center">
              <CustomLoading msg="calculando exposición" icon="fa-cubes"/>
            </div>
          </div>

        );
      } else if(this.props.optim_port_metrics.isLoading){
        return(
          <div className="container">
            <div className="row mt-5 justify-content-center">
              <div className="col-auto">
                  <h4>Optimización</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className="col-auto">
                <Breadcrumb>
                  <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                  <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                  <BreadcrumbItem active>Resultados</BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>
            <div className="row justify-content-center">
              <CustomLoading msg="calculando métricas" icon="fa-calculator"/>
            </div>
          </div>

        );
      } else if (this.props.optim_saa.data==null){
          return(
            <div className='container'>
              <div className="row mt-5 justify-content-center">
                <div className="col-auto">
                    <h4>Optimización</h4>
                </div>
              </div>
              <div className="row m-3 justify-content-center">
                <div className="col-auto">
                  <Breadcrumb>
                    <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                    <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Resultados</BreadcrumbItem>
                  </Breadcrumb>
                </div>
              </div>
              <div className="row justify-content-center m-5">
                  <h6>No se ha optimizado portafolio.</h6>
              </div>
            </div>
          );
      } else if (this.props.optim_port_metrics.data==null || (!this.props.optim_params.frontier_ind && this.props.optim_port_exposure.data==null)){
          return(
            <div className='container'>
              <div className="row mt-5 justify-content-center">
                <div className="col-auto">
                    <h4>Optimización</h4>
                </div>
              </div>
              <div className="row m-3 justify-content-center">
                <div className="col-auto">
                  <Breadcrumb>
                    <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                    <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Resultados</BreadcrumbItem>
                  </Breadcrumb>
                </div>
              </div>
              <div className="row justify-content-center m-5">
                  <h6>No hay datos disponibles..</h6>
              </div>
            </div>
          );
      } else if (this.props.optim_params.frontier_ind) {
        const exp_table = custom_sort_by(transpose(this.props.optim_port_metrics.data.ports_exp[this.state.exp_var], this.state.exp_var, "Portafolio"), "Portafolio", this.props.optim_port_metrics.data.names);
        const valid_metrics = ["Retorno Esperado", "Retorno Promedio Anual.","Volatilidad Anual.", "VeR 99%", "Duración", "Sharpe", "Drawdown"];
        const rets_summ_table = transpose(
          this.props.optim_port_metrics.data.rets_summ.filter(item=>valid_metrics.includes(item["Métrica"])).map(item => pick(item, ['Métrica'].concat(this.props.optim_port_metrics.data.names)))
        , "Métrica", "Portafolio");

        return (
          <div className="container">
            <div className="row mt-5 justify-content-center">
              <div className="col-auto">
                  <h4>Optimización</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className="col-auto">
                <Breadcrumb>
                  <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                  <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                  <BreadcrumbItem active>Resultados</BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>

            <div className="row mt-4 justify-content-center">
              <div className='col' id="risk_ret">
                <h5>Riesgo - Retorno</h5>
                <a className='linkcol' href='#exp'>exposición&darr; {'          '}</a>
              </div>
            </div>
            <div className="row m-2 justify-content-center">
              <div className='col-auto'>
                <p><small>{this.props.optim_port_metrics.data.avail_dates[0]}/{this.props.optim_port_metrics.data.avail_dates[1]}</small></p>
              </div>
            </div>
            <div className="row m-5 justify-content-center">
              <div className='col-lg-6'>
                <div className="row justify-content-center">
                  <div className={`col-auto ${rets_summ_table.length<4 ? "mt-4" : "mt-0"}`}>
                    <RenderVirtualTable 
                      data={rets_summ_table} 
                      to_perc={Object.keys(rets_summ_table[0]).map(k=>["Portafolio", "Duración", "Sharpe"].includes(k) ? false : true)}
                      cell_width={["120px", '65px', '65px', '65px', '65px', '65px', '65px', '65px']}
                      item_size={45}
                      fontsize={12}
                      style="black"
                    />
                  </div>
                </div>
                <div className='row justify-content-center'>
                  <div className='col-auto'>
                    <CSVLink className='link-btn' data={this.props.optim_saa.data.port} filename="allocation"><small>descargar portafolios&darr;</small></CSVLink>
                  </div>
                  <div className='col-auto'>
                    <CSVLink className='link-btn' data={rets_summ_table} filename="rets_summ_table"><small>descargar métricas&darr;</small></CSVLink>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className="row">
                  <div className='col-lg-6'>
                    <ScatterPlot
                      data={rets_summ_table}
                      color="#000000"
                      xlabel="Volatilidad"
                      ylabel={"Retorno Esperado" in rets_summ_table[0] ? "Retorno Esperado" : "Retorno Promedio"}
                      xAxisId="Volatilidad Anual."
                      yAxisId={"Retorno Esperado" in rets_summ_table[0] ? "Retorno Esperado" : "Retorno Promedio Anual."}
                      zAxisId='Portafolio'
                      dataName='Portafolio'
                      width={580}
                      ml={50}
                      showLabels={true}
                      percTooltip={true}
                      xpercAxis={true}
                      ypercAxis={true}
                      legend={false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row m-4 justify-content-center">
              <div className='col'>
                <hr></hr>
              </div>
            </div>
            <div className="row m-4 justify-content-center">
              <div className='col' id="exp">
                <h5>Exposición</h5>
                <a className='linkcol' href='#risk_ret'>riesgo-retorno&uarr; {'          '}</a>
              </div>
            </div>
            <div className="row m-1 justify-content-center">
              <div className='col-6 col-lg-2'>
                  <Input 
                      type="select"
                      value={this.state.exp_var}
                      onChange={(e)=>this.setState({exp_var:e.target.value})}
                      >
                      {Object.keys(this.props.optim_port_metrics.data.ports_exp).map((x,i)=>{
                        return <option key={i}>{x}</option>;
                      })}
                  </Input>
              </div>
            </div>
            <div className="row m-5 justify-content-start">
              <div className='col-lg-6'>
                <div className="row justify-content-center">
                  <div className={`col-auto ${exp_table.length<4 ? "mt-4" : "mt-0"}`}>
                    <RenderVirtualTable 
                      data={exp_table} 
                      to_perc={[false].concat(new Array(Object.keys(exp_table[0]).length - 1).fill(true))}
                      cell_width={["200px"].concat(new Array(this.props.optim_port_metrics.data.names.length).fill("70px"))}
                      item_size={45}
                      fontsize={12}
                      style="black"
                    />
                  </div>
                </div>
                <div className='row m-0 justify-content-center align-items-center'>
                  <div className='col-auto'>
                    <CSVLink className='link-btn' data={this.props.optim_saa.data.port} filename="allocation"><small>descargar portafolios&darr;</small></CSVLink>
                  </div>
                  <div className='col-auto'>
                    <CSVLink className='link-btn' data={exp_table} filename="exp_table"><small>descargar exposición&darr;</small></CSVLink>
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <MultBarPlot 
                  data={this.props.optim_port_metrics.data.ports_exp[this.state.exp_var].map(item=>custom_sort_keys(item, this.props.optim_port_metrics.data.names))}
                  nameKey={this.state.exp_var}
                  vertical={false}
                  angle={0}
                  xtype="category" 
                  ytype="number"
                  colors={colors_sura}
                  ypercAxis={true}
                  percTooltip={true}
                  width={600}
                  ml={50}
                  interval={0}
                  height={450}
                  barsize={20}
                  legend={true}
                />
              </div>
            </div>
          </div>
      );        
      } else {
        let port_assetclass_exp = this.props.optim_port_exposure.data.names.length==1 ? 
          aggregate(this.props.optim_port_exposure.data.w_ac, ['AssetClass', "Currency"], ['Portafolio']).sort(sort_by('value'))
          : aggregate(this.props.optim_port_exposure.data.w_ac, ['AssetClass', "Currency"], ['Portafolio', 'Benchmark']).sort(sort_by('value'));

        const real_rets = this.props.optim_port_metrics.data.real_rets;

        const real_rets_assets = reordered_array_keys(this.props.optim_port_metrics.data.real_rets_assets, 'Periodo');
        
        const rets_summ = this.props.optim_port_metrics.data.rets_summ.map(item=>pick(item, ["Métrica"].concat(this.props.optim_port_metrics.data.names)));

        const series = this.props.optim_port_metrics.data.series.map(item=>pick(item, ["Date"].concat(this.props.optim_port_metrics.data.names)));

        const assets_summ = Object.keys(this.props.optim_port_metrics.data.rets_summ[0]).filter(x=>x!=='Métrica').map(z=>{
                            return {
                              'Activo':z,
                              'Retorno Promedio':this.props.optim_port_metrics.data.rets_summ.filter(x=>x['Métrica']=='Retorno Promedio Anual.')[0][z],
                              'Volatilidad':this.props.optim_port_metrics.data.rets_summ.filter(x=>x['Métrica']=='Volatilidad Anual.')[0][z]
                              };
                          });
        const port_saa = this.props.optim_saa.data.port.filter(item=>item.w>1e-6).map(item=>{
          return {Fondo:item.name, Peso:100*item.w};
        }).sort(sort_by('Peso', "desc"));
        return (
          <div className="container">
            <div className="row mt-5 justify-content-center">
              <div className="col-auto">
                  <h4>Optimización</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
              <div className="col-auto">
                <Breadcrumb>
                  <BreadcrumbItem><Link to='/builder/optim/assets'>Universo Invertible</Link></BreadcrumbItem>
                  <BreadcrumbItem><Link to='/builder/optim/params'>Parámetros</Link></BreadcrumbItem>
                  <BreadcrumbItem active>Resultados</BreadcrumbItem>
                </Breadcrumb>
              </div>
            </div>

            <div className="row m-5 justify-content-center">
              <div className='col' id="exp">
                <h4>Portafolio Recomendado</h4>
                <a className='linkcol' href='#risk'>riesgo-retorno&darr;</a>
                <a className='linkcol' href='#real_rets'>{'  '}retornos realizados&darr;</a>
                <a className='linkcol' href='#assets'>{'  '}activos&darr;</a>
              </div>
            </div>
            <div className="row m-4 align-items-center">
              <div className='col-md-6'>
                <div className="row justify-content-center align-items-start">
                  <div className='col-auto'>
                    <RenderVirtualTable 
                      data={port_saa} 
                      to_perc={[false, true]}
                      cell_width={["250px", '150px']}
                      item_size={45}
                      fontsize={12}
                      style="black"
                    />
                  </div>
                </div>
                <div className="row justify-content-center align-items-center mt-0">
                  <div className='col-auto'>
                    <CSVLink className='link-btn' data={port_saa} filename="portfolio"><small>descargar&darr;</small></CSVLink>
                  </div>
                  <div className='col-auto'>
                    <Button
                      size="sm"
                      className="link-btn"
                      onClick={this.roundPort}
                    >
                      <small>redondear&#10227;</small>
                    </Button>
                  </div>
                </div>
                <div className="row justify-content-center mt-4">
                  <div className='col-auto'>
                    <Button
                      size="sm"
                      className="btn-corp"
                      onClick={()=>this.setState({load_portfolio:true})}
                    >
                      Guardar Portafolio
                    </Button>
                  </div>
                </div>
                <div className="row m-3 justify-content-center">
                  <div className="col-auto">
                    <Alert
                      color='secondary'
                      isOpen={this.props.optim_params.msg!==null} 
                      toggle={()=>this.props.changeModel("optim_params.msg", null)}
                      fade={false}
                      >
                        <small>{this.props.optim_params.msg}</small>
                    </Alert>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <PiePlot 
                  data={port_saa} 
                  width={500}
                  height={400}
                  percTooltip={true}
                  legend={true}
                  legendHeight={50}
                  dataKey='Peso'
                  nameKey='Fondo'
                />
              </div>
            </div>

            <Modal isOpen={this.state.load_portfolio} toggle={()=>this.setState({load_portfolio:!this.state.load_portfolio})}>
              <ModalHeader toggle={()=>this.setState({load_portfolio:!this.state.load_portfolio})}>Guardar Portafolio</ModalHeader>
              <ModalBody>
                <Form onSubmit={this.savePortfolio}>
                  <div className="row m-4 justify-content-center">
                    <div className="col-8 m-1">
                      <Input
                        id='port_name'
                        type='text'
                        placeholder="Nombre..."
                      >
                      </Input>
                    </div>
                  </div>
                  <div className="row m-1 justify-content-center">
                    {this.state.saving_portfolio ?
                      <div className='col-2'>
                        <CustomLoading msg="guardando portafolio" icon="fa-database" />
                      </div>
                    : 
                      <div className="col-auto m-1">
                        <Button 
                          type='submit'
                          className="btn-corp">
                            Guardar
                        </Button>
                      </div>
                    }
                  </div>
                  <div className="row mt-4 justify-content-center">
                    <div className="col m-3">
                      <Alert
                        color='secondary'
                        isOpen={this.state.msg_save!=='' && this.state.msg_save!==null} 
                        toggle={()=>this.setState({msg_save:null})}
                        fade={false}
                        >
                          {this.state.msg_save}
                      </Alert>
                    </div>
                  </div>
                </Form>
              </ModalBody>  
            </Modal>
            
            {/*Exposición*/}
            <div className="row m-5 justify-content-center">
              <div className='col'>
                <h5>Exposición</h5>
                <a className='linkcol' href='#risk'>riesgo-retorno&darr;</a>
                <a className='linkcol' href='#real_rets'>{'  '}retornos realizados&darr;</a>
                <a className='linkcol' href='#assets'>{'  '}activos&darr;</a>

              </div>
            </div>
            {port_assetclass_exp!=null && port_assetclass_exp.length>0 
            ? <div className="row m-4 align-items-center">
                <div className='col-md-6'>
                  <div className="row justify-content-center align-items-start">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={port_assetclass_exp} 
                        to_perc={(this.state.show_fx ? [false, false] : [false]).concat([true, true])}
                        cell_width={["200px", '100px', '100px', '100px']}
                        item_size={30}
                        style="black"
                      />
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <CSVLink className='link-btn' data={port_assetclass_exp} filename="exposure"><small>descargar&darr;</small></CSVLink>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  {this.props.optim_port_exposure.data.names.length>1
                  ? <div className='row justify-content-center'>
                      <div className='col-auto'>
                        <Input bsSize='sm' 
                          type="select" 
                          name="port_id" 
                          value={this.state.port_id} 
                          onChange={(e)=>this.setState({port_id:e.target.value})}>
                          {this.props.port_metrics.data.names.map((x,i)=>{
                            return (<option key={i}>{x}</option>);
                          })}
                        </Input>
                      </div>
                    </div>
                  : null
                  }
                  <div className='row justify-content-center'>
                    <div className='col-md-12'>
                      <PiePlot 
                        data={port_assetclass_exp.filter(x=>x[this.state.port_id]>0).map(x=>{
                          if (this.state.show_fx){
                            return {name:x['AssetClass'] + ' ' + x['Currency'], value:x[this.state.port_id]};
                          }else{
                            return {name:x['AssetClass'], value:x[this.state.port_id]};
                          }
                        })} 
                        width={500}
                        height={400}
                        percTooltip={true}
                        legend={true}
                        legendHeight={50}
                      />
                    </div>
                  </div>
                </div>
              </div>
            : <></>
            }
            {series!==null 
            ?
            <>
              <div className="row justify-content-center align-items-center">
                <div className='col p-5'>
                  <hr />
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className='col' id='risk'>
                  <h5>Riesgo - Retorno</h5>
                  <a className='linkcol' href='#exp'>portafolio&uarr;</a>
                  <a className='linkcol' href='#real_rets'>{'  '}retornos realizados&darr;</a>
                  <a className='linkcol' href='#assets'>{'  '}activos&darr;</a>
                </div>
              </div>
              <div className="row m-1 justify-content-center">
                <div className='col-auto'>
                  <p><small>{series[0].Date} / {series.slice(-1)[0].Date}</small></p>
                </div>
              </div>
              <div className="row m-5 justify-content-center align-items-start">
                  <div className='col-md-6'>
                    <div className="row justify-content-center">
                      <div className='col-auto'>
                        <RenderVirtualTable 
                          data={rets_summ} 
                          to_perc={[false, true, true]} 
                          to_perc_row={[true, true, true, true, false, true, false, false, false, false]}
                          cell_width={["200px", '150px']}
                          item_size={30}
                          fontsize={12}
                          style="black"
                          />
                      </div>
                    </div>
                    <div className="row justify-content-center mt-0">
                      <div className='col-auto'>
                        <CSVLink className='link-btn' data={rets_summ} filename="risk_return"><small>descargar&darr;</small></CSVLink>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <MultLineTsPlot 
                       data={series}
                       width={500}
                       xkey='Date'
                       ykeys={this.props.optim_port_metrics.data.names}
                       xtype='category'
                       ytype='number'
                       colors = {['#000000']}
                       percTooltip={false}
                       legend={true ? this.props.optim_port_metrics.data.names.length > 1 : false}
                       ml={120}
                    />
                  </div>
                </div>
              </>
            : <></>
            }
            {/*Retornos*/}
            <div className="row m-4 justify-content-center">
              <div className='col'>
                <hr></hr>
              </div>
            </div>
            <div className="row m-5 justify-content-center">
              <div className='col' id="real_rets">
                <h5>Retornos Realizados</h5>
                <a className='linkcol' href='#exp'>portafolio&uarr;</a>
                <a className='linkcol' href='#risk'>{"    "}riesgo-retorno&uarr;</a>
                <a className='linkcol' href='#assets'>{"    "}activos&darr;</a>
              </div>
            </div>
            {real_rets!==null 
            ? <div className="row m-5 justify-content-center align-items-start">
                <div className='col-md-6'>
                  <div className="row justify-content-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={real_rets} 
                        to_perc={[false, true, true]}
                        cell_width={["200px", '150px']}
                        item_size={30}
                        style="black"
                        />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  {this.props.optim_port_metrics.data.names.length>1
                  ? <MultBarPlot 
                      data={real_rets}
                      nameKey='Periodo'
                      vertical={true}
                      angle={0}
                      ytype="category" xtype="number"
                      colors={["#000000", "#2803fc"]}
                      xpercAxis={true}
                      moneyTooltip={false}
                      width={500}
                      ml={120}
                      interval={0}
                      height={400}
                      barsize={10}
                    />
                  : <BarPlot 
                      y={real_rets.map(x=>x.Periodo)}
                      x={real_rets.map(x=>x.Portafolio)}
                      layout="vertical"
                      angle={0}
                      ytype="category" xtype="number"
                      color="#000000"
                      xpercAxis={true}
                      moneyTooltip={true}
                      width={500}
                      ml={120}
                      interval={0}
                      height={400}
                      barsize={10}
                    />
                  }
                </div>
              </div>
            : <></>
            }
            {/*Riesgos*/}
              {assets_summ?.filter(item=>item.Activo!=='Portafolio').length>0 ?
              <>
                <div className="row justify-content-center align-items-center">
                  <div className='col p-5'>
                    <hr />
                  </div>
                </div>
                <div className="row m-4 justify-content-center align-items-center">
                  <div className='col-md-6' id="assets">
                    <h5><b>Activos</b></h5>
                    <a className='linkcol' href='#exp'>portafolio&uarr;</a>
                    <a className='linkcol' href='#real_rets'>{'  '}retornos realizados&uarr;</a>
                    <a className='linkcol' href='#risk'>{'  '}riesgo-retorno&uarr;</a>
                  </div>
                </div>
                <div className="row m-4 justify-content-center align-items-center">
                  <div className='col-md-6'>
                    <h6>Retornos Realizados</h6>
                  </div>
                </div>
                {Object.keys(real_rets_assets[0]).length>8 ?
                <div className="row m-4 justify-content-center align-items-center">
                  <div className="col-auto">
                    <RenderVirtualTable 
                      data={real_rets_assets} 
                      to_perc={[false, true, true]} 
                      cell_width={new Array(Object.keys(real_rets_assets[0]).length).fill('70px')}
                      item_size={40}
                      fontsize={12}
                      style="black"
                      />
                  </div>
                </div>
                :
                <>
                  <div className="row justify-content-center">
                    <div className='col-1'>
                      <Input bsSize='sm' type="select" value={this.state.ret_period} 
                        onChange={(e)=>this.setState({ret_period:e.target.value})}
                      >
                        {real_rets_assets.map(k=>k.Periodo).map((x,i)=>{
                          return (<option key={i}>{x}</option>);
                        })}
                      </Input>
                    </div>
                  </div>
                  <div className="row mt-5 justify-content-center align-items-start">
                    <div className='col-6'>
                      <div className="row justify-content-center">
                        <div className="col-auto">
                          <RenderVirtualTable 
                            data={real_rets_assets} 
                            to_perc={[false, true, true]} 
                            cell_width={new Array(Object.keys(real_rets_assets[0]).length).fill('100px')}
                            item_size={40}
                            fontsize={12}
                            style="black"
                            />
                        </div>
                      </div>
                    </div>
                    <div className='col-6'>
                      <MultBarPlot 
                        data={Object.keys(real_rets_assets[0]).filter(k=>k!=='Periodo').map(x=>{
                          return {asset:x, Retorno:real_rets_assets.filter(item=>item.Periodo==this.state.ret_period)[0][x]}
                        })}
                        nameKey='asset'
                        vertical={true}
                        angle={0}
                        ytype="category" xtype="number"
                        colors={["#000000", "#2803fc"]}
                        xpercAxis={true}
                        percTooltip={true}
                        moneyTooltip={false}
                        width={500}
                        interval={0}
                        height={400}
                        barsize={30}
                        fontsize={11}
                      />
                    </div>
                  </div>
                </>
                }

                <div className="row m-4 justify-content-center align-items-center">
                  <div className='col-md-6'>
                    <h6>Riesgo - Retorno</h6>
                  </div>
                </div>
                <div className="row m-4 justify-content-center align-items-center">
                  <div className='col-md-6'>
                    <div className="row justify-content-center align-items-center">
                      <div className='col-auto'>
                        <RenderVirtualTable 
                          data={assets_summ.filter(item=>item.Activo!=='Portafolio').sort(sort_by('Volatilidad'))} 
                          to_perc={[false, true, true]} 
                          cell_width={['200px', "100px", '100px']}
                          item_size={40}
                          fontsize={12}
                          style="black"
                          />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <ScatterPlot
                      data={assets_summ.filter(x=>x.Activo!=='Portafolio')}
                      color="#000000"
                      data2={assets_summ.filter(x=>x.Activo=='Portafolio')}
                      color2="#0303fc"
                      xlabel="Volatilidad"
                      ylabel="Retorno Promedio"
                      xAxisId="Volatilidad"
                      yAxisId="Retorno Promedio"
                      zAxisId='Activo'
                      dataName='Activos'
                      dataName2='Portafolio'
                      legend={true}
                      width={500}
                      ml={50}
                      xpercAxis={true}
                      ypercAxis={true}
                      percTooltip={true}
                    />
                  </div>
                </div>
              </>
              :null
              }
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(PortOptim));